import { Injectable } from '@angular/core';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SharedSettings } from '../models/shared-settings';
import { Cacheable } from 'ts-cacheable';
import { User } from '../models/user';
import {buildQueryParams, url} from "@shared/helpers/url";

@Injectable({
    providedIn: 'root'
})
export class UsersService {
    private static readonly cacheBuster = new Subject<void>();

    constructor(
        private http: HttpClient,
        private settings: SharedSettings) {
    }

    @Cacheable({
        maxAge: 5 * 1000 * 60,
        cacheBusterObserver: UsersService.cacheBuster
    })
    GetUsers(query?: string, roles?: string[]): Observable<User[]> {
        const params = buildQueryParams({
            roles,
            filter: query,
        })

        return this.http.get<User[]>(this.settings.apiBaseUrl + url`Users?${params}`);
    }

    @Cacheable({
        maxAge: 5 * 1000 * 60,
        cacheBusterObserver: UsersService.cacheBuster
    })
    GetUser(userId: string): Observable<User> {
        return this.http.get<User>(this.settings.apiBaseUrl + url`Users/${userId}`);
    }

    ImpersonateUser(userId: string): Observable<User> {
        return this.http.post<User>(this.settings.apiBaseUrl + url`Users/impersonation`, JSON.stringify(userId), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    CancelImpersonateUser() {
        return this.http.delete(this.settings.apiBaseUrl + url`Users/impersonation`);
    }

    GetAvatarUrl(userId: string): string {
        return this.settings.apiBaseUrl + `Users/${userId}/photo`;
    }
}
